<template>
<div class="chapter">
<div class="inner_page">
<p class="fm">“Let there be light!” said God,</p>
<p class="fm1">and there was light!</p>
<p class="fm2">“Let there be blood!” says man,</p>
<p class="fm1">and there’s a sea!</p>
<p class="fm3">—Lord Byron, <i>Don Juan</i></p>
<p class="fm4">“Let them drown in their own stinking sea of blood!”</p>
<p class="fm5"><span>—Mack Bolan,</span></p>
<p class="fm5"><span>THE EXECUTIONER</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// franmatter01.vue?28d27cdf